import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import Images from "../../Images";
import Navlist from "./navList";
import { getToken } from '../../authetication/loginState';
import "./Navbar.css";
import { useMediaQuery } from '@mui/material';

function Navbar({ loginState }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [controller, setController] = useState(false);
  const [open, setOpen] = useState(false);
  const [mobileState, setMobileState] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    setController(false);
  }, [location]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector('.newNavbar');
      if (nav) {
        if (window.scrollY > 10) {
          nav.classList.add('scrolled');
        } else {
          nav.classList.remove('scrolled');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setMobileState(window.innerWidth <= 850);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isLoggedIn = getToken();

  const getNavbarClass = () => {
    const { pathname } = location;
    
    switch (true) {
      case pathname === '/':
      case pathname.includes('nursing'):
      case pathname.includes('flight-attendant'):
      case pathname.includes('alternative'):
      case pathname.includes('referral'):
        return 'newNavbar';
      
      case pathname.includes('/mockInterviewerZoom'):
      case pathname.includes('/starter-pack'):
      case pathname.includes('/profile'):
      case pathname.includes('/mockInterviewerInput'):
        return 'navbar mockInterviewerZoom';
        
      case pathname.includes('/mockInterviewer'):
        return 'navbar home';
        
      default:
        return 'navbar other';
    }
  };

  return (
  !location.pathname.startsWith('/interview/') && !location.pathname.startsWith('/job/') 
   && !location.pathname.startsWith('/profile-update/') && !location.pathname.startsWith('/verify-done') ? (
    <nav className={getNavbarClass()}>
      <div className="navbar__logo">
        <img
          src={Images.NORA_LOGO}
          alt="Nora AI"
          onClick={() => navigate("/")}
          className={open ? "noSmall" : ""}
        />
      </div>

      <div
        className="navbar__navController"
        onClick={() => setOpen(!open)}
      >
        <div className="navbar__bar" />
        <div className="navbar__bar" />
        <div className="navbar__bar" />
      </div>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        anchor="top"
        className={`navbar__nav ${open ? "open" : "navbar_noDisplay"}`}
      >
        <Navlist loginState={loginState} open={open} setOpen={setOpen} mobileState={mobileState} />
      </Drawer>
      
      {!mobileState && (
        <Navlist loginState={loginState} open={open} setOpen={setOpen} mobileState={mobileState} />
      )}
    </nav>
  ) : null
);
}

export default Navbar;